export enum PerfilResponsavel {
  PROFESSOR = 'professor',
  TUTOR = 'tutor',
}

export type TipoTurma = 'PAI' | 'NORMAL';
export type TipoCurso =
  | 'GRADUAÇÃO'
  | 'GRADUAÇÃO TECNOLÓGICA'
  | 'ESPECIALIZAÇÃO'
  | 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO';

export enum FormatoTurma {
  PRESENCIAL = 'presencial',
  DIGITAL = 'digital',
}

export interface EducadorTurma {
  nome: string;
  perfil: PerfilResponsavel;
}
